import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import {
  LayoutDashboard,
  Inbox,
  Users,
  Briefcase,
  LogOut,
} from "lucide-react";

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm transition-colors ${
    isActive
      ? "bg-[#f5c76e]/10 text-[#f5c76e] border border-[#f5c76e]/30"
      : "text-[#bdb6c4] hover:bg-white/[0.04] hover:text-white border border-transparent"
  }`;

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-[#0a0a14] text-[#f4ede1]">
      <aside className="w-64 border-r border-white/10 bg-[#0c0b1a] flex flex-col">
        <div className="px-6 py-6 border-b border-white/10">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#f5c76e] shadow-[0_0_14px_rgba(245,199,110,.7)]" />
            <span className="font-display text-base font-bold tracking-tight">
              Warp Admin
            </span>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#6b6677] mt-2">
            Mission control
          </p>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1" data-testid="admin-nav">
          <NavLink to="/admin" end className={linkCls} data-testid="nav-dashboard">
            <LayoutDashboard size={16} /> Dashboard
          </NavLink>
          <NavLink to="/admin/leads" className={linkCls} data-testid="nav-leads">
            <Inbox size={16} /> Leads
          </NavLink>
          <NavLink to="/admin/clients" className={linkCls} data-testid="nav-clients">
            <Users size={16} /> Clients
          </NavLink>
          <NavLink to="/admin/projects" className={linkCls} data-testid="nav-projects">
            <Briefcase size={16} /> Projects
          </NavLink>
        </nav>

        <div className="px-4 py-4 border-t border-white/10">
          <p className="text-xs text-[#9c95a8] mb-2 truncate" title={user?.email}>
            {user?.name || "Admin"} · <span className="text-[#6b6677]">{user?.email}</span>
          </p>
          <button
            onClick={onLogout}
            data-testid="logout-button"
            className="w-full inline-flex items-center justify-center gap-2 px-3 py-2 rounded-lg border border-white/10 text-sm text-[#bdb6c4] hover:bg-white/[0.04] hover:text-white transition-colors"
          >
            <LogOut size={14} /> Log out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto">
        <div className="max-w-6xl mx-auto px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
